import React from 'react';

const ArrowNotFilled = ({ show, onClick, className = '' }) => (
    <div
        className = {`arrow-not-filled ${ show.toLowerCase() } ${ className }`}
        onClick = { onClick }
    ></div>
)

export default ArrowNotFilled;


// WEBPACK FOOTER //
// ./src/components/common/icons/arrow.js